import _orderBy from 'lodash/orderBy';
// Serialization
import { deserialize } from 'serializr';
import { operatorSchema } from './schemas';

/**
* Serialization
*/
const deserializeOperator = (data) => deserialize(operatorSchema, data);

/**
* Utils
*/
const sortOperators = (operators, fields = ['country', 'name'], dirs = ['asc', 'asc']) => (_orderBy(operators, fields, dirs));

const operatorDesc = (operator) => `${operator.name} (${operator.country})`;
const operatorListDesc = (operator) => `${operator.country} - ${operator.name}`;
const operatorFieldDesc = (operator) => `${operator.country} - ${operator.name} (${operator.code})`;

/**
* Model
*/
const operator = {
  // Name and icon
  name: 'operator',

  // Serialization
  deserialize: deserializeOperator,

  // Sort elements
  sortElements: sortOperators,

  // Utils
  desc: operatorDesc,
  listDesc: operatorListDesc,
  fieldDesc: operatorFieldDesc,
};

module.exports = operator;



// WEBPACK FOOTER //
// ./models/operator.js